import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/aiCreate/SpacePortal",
  name: "aiCreateSpacePortal",
  component: function component() {
    return import("../../../views/dev-plug/ai-create/SpacePortal.vue");
  },
  meta: {
    title: "AI创作",
    foot: true
  }
}, {
  path: "/aiCreate/SpaceDetails",
  name: "aiCreateSpaceDetails",
  component: function component() {
    return import("../../../views/dev-plug/ai-create/SpaceDetails.vue");
  },
  meta: {
    title: "AI创作",
    foot: true
  }
}, {
  path: "/aiCreate/DigitalHuman",
  name: "aiCreateDigitalHuman",
  component: function component() {
    return import("../../../views/dev-plug/ai-create/DigitalHuman.vue");
  },
  meta: {
    title: "上传数字人分身",
    foot: true,
    notKeepAlive: true
  }
}, {
  path: "/aiCreate/record",
  name: "aiCreateRecord",
  component: function component() {
    return import("../../../views/dev-plug/ai-create/record.vue");
  },
  meta: {
    title: "权益明细",
    foot: true
  }
}, {
  path: "/aiCreate/VideoCreation",
  name: "aiCreateVideoCreation",
  component: function component() {
    return import("../../../views/dev-plug/ai-create/VideoCreation.vue");
  },
  meta: {
    title: "视频创作",
    foot: true,
    notKeepAlive: true
  }
}, {
  path: "/aiCreate/VoiceClon",
  name: "aiCreateVoiceClon",
  component: function component() {
    return import("../../../views/dev-plug/ai-create/aiCreateVoiceClon.vue");
  },
  meta: {
    title: "创建声音克隆",
    foot: true,
    notKeepAlive: true
  }
}, {
  path: "/aiCreate/Lipping",
  name: "aiCreateLipping",
  component: function component() {
    return import("../../../views/dev-plug/ai-create/aiCreateLipping.vue");
  },
  meta: {
    title: "创建声音克隆",
    foot: true
  }
}];